import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { COACH_URL, coaching, type Today } from './api';
import { useInviteLink, useRefreshCoaching } from './queries';
import { shareText } from './share';

/**
 * Today's affirmation as a practice: "I said it" records it once (it moves
 * the Mindset part of the score) and Share forwards it with the member's own
 * invite link. Shared by every surface that shows the affirmation.
 */
export function useAffirmation(today: Today) {
  const refresh = useRefreshCoaching();
  const [said, setSaid] = useState(false);
  const affirm = useMutation({
    mutationFn: () => coaching.practice('affirmation'),
    onSuccess: () => {
      setSaid(true);
      coaching.event('affirmation_played');
      void refresh();
    },
  });
  // A forwarded affirmation is also a way in; the plain app url until the code has loaded.
  const invite = useInviteLink();
  const share = async () => {
    const outcome = await shareText({
      title: 'Today’s affirmation',
      text: `“${today.affirmation}”`,
      url: invite ?? COACH_URL,
    });
    if (outcome === 'shared' || outcome === 'copied') {
      coaching.event('content_shared', { kind: 'affirmation', how: outcome });
    }
  };
  return {
    affirmed: said || today.practicesDone.includes('affirmation'),
    pending: affirm.isPending,
    affirm: () => affirm.mutate(),
    share,
  };
}
